import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const confirmClientInactivity = async (clientId, payload) => {
    try {
        const token = Cookies.get("Bearer");
        const response = await axios.put(
            `${FIRMFLOWURL}api/Client/${clientId}/inactive-reason-confirmation`,
            payload,
            { headers: { Authorization: token } },
        );

        return { ...response, success: true };
    } catch (error) {
        const status = error?.response?.status;

        if (status === 401) {
            Cookies.remove("Bearer");
            window.location.replace("/");
        }

        return {
            success: false,
            status,
            data: error?.response?.data,
            message:
                error?.response?.data?.message ||
                error?.message ||
                "The inactive reason could not be saved. Please try again.",
        };
    }
};
